export const OverlayConstants = {
  none: null,
  RetrieveQuote: 'RetrieveQuote',
  Callback: 'Callback',
  CalculationInterstitial: 'CalculationInterstitial',
  SessionTimeout: 'SessionTimeout',
};
export const JavaScriptLinkConstants = {
  GO_BACK_ONE: -1,
  GO_BACK_TWO: -2,
  JAVASCRIPT_Text: 'javascript',
};
